<template lang="pug">
  div.analytic-report-apo-selector
    div.body.body-table
      div.table-choose-panel
        div.toolbar-table
          div.select
          div.toolbar.toolbar--modal
            div.line
              div.search
                input(
                v-model="q"
                :placeholder="`Поиск по всем ${apoLabel}`"
                ).search

    div.body
      div.col
        template(
        v-for="apo, index in groupedApo"
        )
          e-form-group(
          v-if="apo.columnIndex === 1"
            :key="apo.id"
          :name="`${apo.id}`"
          inputType="suggestion[]"
            :label="`Региональный оператор ${apo.name}`"
              :model="fields._apo"
              :options="apo.options"
          tabView="tab1"
            :enableSelectAll="true"
              :alwaysOpen="true"
              :useOuterOptionsFilter="true"
          :selectAllOnCreate="true"
          )

      div.col
        template(
        v-for="apo, index in groupedApo"
        )
          e-form-group(
          v-if="apo.columnIndex === 2"
            :key="apo.id"
          :name="`${apo.id}`"
          inputType="suggestion[]"
            :label="`Региональный оператор ${apo.name}`"
              :model="fields._apo"
              :options="apo.options"
          tabView="tab1"
            :enableSelectAll="true"
              :alwaysOpen="true"
              :useOuterOptionsFilter="true"
          :selectAllOnCreate="true"
          )

      div.col
        template(
        v-for="apo, index in groupedApo"
        )
          e-form-group(
          v-if="apo.columnIndex === 3"
            :key="apo.id"
              :name="`${apo.id}`"
          inputType="suggestion[]"
            :label="`Региональный оператор ${apo.name}`"
              :model="fields._apo"
              :options="apo.options"
          tabView="tab1"
            :enableSelectAll="true"
              :alwaysOpen="true"
              :useOuterOptionsFilter="true"
          :selectAllOnCreate="true"
          )

</template>

<script>
  import {atu} from '../../../api/api-endpoints.js'
  import world from '../../../utils/word.js'

  export default {
    name: 'r-analytic-report-apo-selector',
    title: false,
    data () {
      return {
        q: ''
      }
    },
    props: {
      fields: {
        type: Object,
        default: function () {
          return {}
        }
      },
      apoLabel: {
        type: String,
        default: 'АПО'
      }
    },
    computed: {
      apo () {
        return this.$store.getters.readUrlEndpoint(this.getApoEndpoint(this.$route)).data || []
      },
      apoFiltered () {
        let options = this.apo
        let regExp = world.getRegExp(this.q || '', 'i')
        let founded = options.filter((item) => {
          // fix: 5b939d0be463f700190440dc
          return (item && item['name'] && item['name'].search(
            regExp
          ) > -1)
        })
        if (founded.length === 0) {
          regExp = world.getRegExp(world.engToRus(this.q || ''), 'i')
          founded = options.filter((item) => {
            return (item && item['name'] && item['name'].search(
              regExp
            ) > -1)
          })
        }
        return founded
      },
      groupedApo () {
        let apos = this.apo
        let aposFiltered = this.apoFiltered
        let groups = {}
        apos.forEach(v => {
          let groupKey = v.apo ? v.apo.id : 1
          if (!groups.hasOwnProperty(groupKey)) {
            groups[groupKey] = {
              id: groupKey,
              name: v.apo ? v.apo.name : this.apoLabel + ' ' + groupKey,
              options: []
            }
          }
          if (aposFiltered.findIndex(f => f.id === v.id) > -1) {
            groups[groupKey].options.push(v)
          }
        })
        // reorder columns by id
        let columnIndex = 1
        let columnsCount = 3
        for (let groupKey in groups) {
          groups[groupKey].columnIndex = columnIndex
          columnIndex++
          if (columnIndex > columnsCount) {
            columnIndex = 1
          }
        }
        console.log('groups', groups)
        return groups
      }
    },
    methods: {
      getApoEndpoint (route) {
        return atu.atuObjects({
          query: {
            'per-page': -1,
            expand: 'apo'
          }
        })
      }
    },
    asyncData ({store, route, fromRoute, methods}) {
      let promises = []

      if (methods.getApoEndpoint(route) !== null) {
        promises.push(store.dispatch('updateUrlEndpoint', {endpoint: methods.getApoEndpoint()}))
      }

      if (promises.length === 0) {
        return Promise.resolve(1)
      }

      return Promise.all(promises)
    }
  }
</script>
